import { eDoiTuongDaoTaoActionsObj } from "../../action-types/category/IStuDoiTuongDaoTaoActions";
import { generateActions } from "../generateActions";

export const doiTuongDaoTaoActions = {
  ...generateActions(eDoiTuongDaoTaoActionsObj, "DOI_TUONG_DAO_TAO"),
};
